import classNames from "classnames"
import React from "react"

import { ToastProps } from "../../../../Toast"

import { Checkbox } from "@components/elements/V2/Inputs/Checkbox"
import { Color } from "@constants/V2/color"
import { getBorderColorClass } from "@utils/V2/color"

export type ProductOptionProps = {
  id: number
  label: string
  isActive?: boolean
  onClick?: (id: number) => void
  /*
    The toast prop is not used in this component but makes sense to be here because
    every ProductOption can have it's own toast message and only shows when the option is active.

    The toast renders outside of the ProductOptions container in MultiProducts/index.tsx
  */
  toast?: ToastProps
}

const ProductOption = ({
  id,
  label,
  isActive = false,
  onClick,
}: ProductOptionProps) => {
  return (
    <div
      className={classNames(
        "rounded-16 border px-16 py-12 sm:py-16",
        isActive ? getBorderColorClass(Color.Blue) : "border-charcoal/20"
      )}
      onClick={() => onClick && onClick(id)}
    >
      <Checkbox
        id={`product-option-${id}`}
        label={label}
        isChecked={isActive}
      />
    </div>
  )
}

export default ProductOption
